<template>
  <div class="container-fluid">
    <splitpanes
      class="default-theme"
      :style="{ height: splitPaneHeight }"
      :size="10"
    >
      <pane
        size="20"
        max-size="50"
        v-bind:style="{
          float: 'left',
          'overflow-y': 'auto',
        }"
      >
        <div class="row" style="margin: 5px">
          <div class="col" style="text-align: center">
            <b-button-group>
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesToday"
                >{{ $store.state.localization.data.common.periodTimesOptions.today }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesYesterday"
                >{{ $store.state.localization.data.common.periodTimesOptions.yesterday }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesLastWeek"
                >{{ $store.state.localization.data.common.periodTimesOptions.lastWeek }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesLastMonth"
                >{{ $store.state.localization.data.common.periodTimesOptions.lastMonth }}</b-button
              >
            </b-button-group>
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-2" style="margin: 5px; font-size: 12px">
            <label>{{ $store.state.localization.data.common.beginPeriodLabel }}:</label>
          </div>
          <div class="col-5" style="margin: 5px">
            <input
              type="date"
              style="font-size: 12px; width: 120px"
              v-model="beginDate"
            />
          </div>
          <div class="col-3" style="margin: 5px">
            <input type="time" style="font-size: 12px" v-model="beginTime" />
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-2" style="margin: 5px; font-size: 12px">
            <label>{{ $store.state.localization.data.common.endPeriodLabel }}:</label>&Tab;
          </div>
          <div class="col-5" style="margin: 5px">
            <input
              type="date"
              style="font-size: 12px; width: 120px"
              v-model="endDate"
            />&Tab;
          </div>
          <div class="col-3" style="margin: 5px">
            <input type="time" style="font-size: 12px" v-model="endTime" />
          </div>
        </div>

        <div class="row">
          <div class="col-2" style="margin: 5px; font-size: 12px">
            <label>{{ $store.state.localization.data.mainPage.azk.users.tableColumns.userName }}:</label>&Tab;
          </div>
          <div class="col">
            <vue-multi-select
              v-model="users.values"
              v-bind:filters="usersFilters"
              search
              v-bind:searchPlaceholder="$store.state.localization.data.mainPage.reports.searchLabel"
              :options="users.options"
              :selectOptions="users.data"
              v-bind:btnLabel="tankBtnLabel"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2" style="margin: 5px; font-size: 12px">
            <label>{{ $store.state.localization.data.mainPage.logs.tableColumns.type }}:</label>&Tab;
          </div>
          <div class="col">
            <vue-multi-select
              v-model="logTypes.values"
              v-bind:filters="logTypeFilters"
              search
              v-bind:searchPlaceholder="$store.state.localization.data.mainPage.reports.searchLabel"
              :options="logTypes.options"
              :selectOptions="logTypes.data"
              v-bind:btnLabel="tankBtnLabel"
            />
          </div>
        </div>

        <div class="row">
          <div class="col" style="margin: 5px">
            <b-button
              style="font-size: 12px"
              class="btn-block"
              variant="success"
              @click="getLogs"
              >{{ $store.state.localization.data.mainPage.logs.getLogsButton }}</b-button
            >
          </div>
        </div>
        <div class="row">
          <div class="col" style="margin: 5px">
            <div
              v-html="tableContent"
              class="text-center table-responsive"
            ></div>
          </div>
        </div>
      </pane>
      <pane size="80">
        
        <div class="text-center" v-show="isLogsLoading">
          <div>
            <b-spinner
              label="Spinning"
              variant="success"
              style="width: 10rem; height: 10rem"
            ></b-spinner>
          </div>
        </div>
        <div class="row" style="height: 100%;">
          <div class="col-12" style="height: 100%;">
            <b-table
              class="textMiddle"
              style="height: 100%;"
              small
              hover
              bordered
              show-empty
              responsive
              head-variant="light"
              selectable
              select-mode="single"
              :items="logs"
              :fields="logHeaders"
              v-bind:emptyText="$store.state.localization.data.common.table.noData"
            >
              <template v-slot:foot()="data">
                <span class="text-success">{{ report.summary[data.column] }}</span>
              </template>
            </b-table>
          </div>
        </div>
      </pane>
    </splitpanes>
    <b-modal ref="error-modal">
      <template v-slot:modal-header="{}">
        <div></div>
      </template>
      <div class="text-center" style="font-size: 12px">
        {{ this.serverError }}
      </div>
      <template v-slot:modal-footer="{ ok }">
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.hide
        }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vueMultiSelect from "vue-multi-select";
import "vue-multi-select/dist/lib/vue-multi-select.css";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import {
  utilsService,
  logService,
  userService,
  roleService
} from "../../../services";

export default {
  name: "Logs",
  components: { Splitpanes, Pane, vueMultiSelect },
  props: {
    fuelTanks: Array,
  },
  data() {
    return {
      beginDate: null,
      beginTime: null,
      endDate: null,
      endTime: null,
      beginDateTime: null,
      endDateTime: null,
      serverError: null,
      users: {
        values: [],
        data: [],
        options: {
          multi: false,
          labelName: "label",
        },
      },
      logTypes: {
        values: [],
        data: [],
        options: {
          multi: false,
          labelName: "label",
        },
      },
      isValidationError: false,
      isLogsLoading: false,
      validationError: null,
      chartColors: null,
      chart: null,
      tableContent: "",
      logs: []
    };
  },
  computed: {
    logHeaders() {
      const headers = [];

      for (let key in this.$store.state.localization.data.mainPage.logs.tableColumns) {
          if (
            key == "created" ||
            key == "user" ||
            key == "message"
          ) {
            headers.push({
              key: key,
              label:
                this.$store.state.localization.data.mainPage.logs.tableColumns[
                  key
                ],
              thClass: "textMiddle",
              tdClass: key === "message" ? "textNarrow" : ""
            });
          }
        }

      return headers;
    },
    splitPaneHeight() {
      const LEFT_TOP_POSITION_Y = 50;

      return `${document.documentElement.clientHeight - LEFT_TOP_POSITION_Y}px`;
    },
    usersFilters() {
      return [
        {
          nameAll: this.$store.state.localization.data.common.setAllLabel,
          nameNotAll: this.$store.state.localization.data.common.resetAllLabel,
          func() {
            return true;
          },
        },
      ];
    },
    tankBtnLabel() {
      return (values) =>
        `${this.$store.state.localization.data.mainPage.reports.selectFilterValueLabel}: (${values.length})`;
    },
    logTypesFilters() {
      return [
        {
          nameAll: this.$store.state.localization.data.common.setAllLabel,
          nameNotAll: this.$store.state.localization.data.common.resetAllLabel,
          func() {
            return true;
          },
        },
      ];
    },
  },
  async created() {
    if (
      this.$store.state.authentication.roles.indexOf(
        roleService.SUPER_ADMIN_ROLE
      ) != -1 ||
      this.$store.state.authentication.roles.indexOf(
        roleService.ADMIN_ROLE
      ) != -1
    ) {
      const today = new Date();
  
      const todayString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
  
      this.beginDate = todayString;
      this.beginTime = "00:00:00";
  
      this.endDate = todayString;
      this.endTime = "23:59:00";
  
      const usersResponse = await userService.getUsers();
  
      if (usersResponse.isSuccess) {
        usersResponse.data.users.sort(function (a, b) {
          return a.userName.toUpperCase() > b.userName.toUpperCase() ? 1 : -1;
        });
  
        for (let i = 0; i < usersResponse.data.users.length; i++) {
          this.users.data.push({
              key: usersResponse.data.users[i].id,
              label: usersResponse.data.users[i].userName
          });
        }
      }

      const filteredLogTypes = ['1', '2', '3', '178', '5', '8', '9', '10', '11', '12', '13', '23', '173', '174', '180', '14']

      for (let key in this.$store.state.localization.data.mainPage.logs.templates) {
        if (filteredLogTypes.includes(key)) {
          this.logTypes.data.push({
              key: parseInt(key),
              label: this.$store.state.localization.data.mainPage.logs.templates[key]
          });
        }
      }
    }
  },
  mounted() {
    //the ugliest way for changing styles of vue-multi-select element
    const chartsElementDiv = document.querySelector(
      "#app > div > div > div:nth-child(3) > div > div:nth-child(1) > div:nth-child(5) > div > div"
    );

    chartsElementDiv.style.width = "100%";

    const chartsElementButton = document.querySelector(
      "#app > div > div > div:nth-child(3) > div > div:nth-child(1) > div:nth-child(5) > div > div > button"
    );

    chartsElementButton.style.width = "100%";
    chartsElementButton.style.fontSize = "12px";
    chartsElementButton.style.textAlign = "left";

    const fuelTanksElementDiv = document.querySelector(
      "#app > div > div > div:nth-child(3) > div > div:nth-child(1) > div:nth-child(7) > div > div"
    );

    fuelTanksElementDiv.style.width = "100%";

    const fuelTanksElementButton = document.querySelector(
      "#app > div > div > div:nth-child(3) > div > div:nth-child(1) > div:nth-child(7) > div > div > button"
    );

    fuelTanksElementButton.style.width = "100%";
    fuelTanksElementButton.style.fontSize = "12px";
    fuelTanksElementButton.style.textAlign = "left";
  },
  methods: {
    async getLogs() {
      this.beginDateTime = new Date(
        (this.beginDate + " " + this.beginTime).replace(/-/g, "/")
      );
      this.endDateTime = new Date(
        (this.endDate + " " + this.endTime).replace(/-/g, "/")
      );

      if (isNaN(this.beginDateTime)) {
        this.validationError =
          this.$store.state.localization.data.common.validations.beginPeriod;
        this.isValidationError = true;

        return;
      }

      if (isNaN(this.endDateTime)) {
        this.validationError =
          this.$store.state.localization.data.common.validations.endPeriod;
        this.isValidationError = true;

        return;
      }

      if (this.beginDateTime > this.endDateTime) {
        this.validationError =
          this.$store.state.localization.data.common.validations.endPeriodInvalid;
        this.isValidationError = true;

        return;
      }

      try {
        this.isLogsLoading = true;

        this.logs = [];

        const userId = this.users.values.length != 0 ? this.users.values[0].key : null
        const logType = this.logTypes.values.length != 0 ? this.logTypes.values[0].key : null

        const logsResponse = await logService.getLogsByFilters(
          this.beginDateTime,
          this.endDateTime,
          userId,
          logType
        );

        if (logsResponse.isSuccess) {
          for (let i = 0; i < logsResponse.data.logs.length; i++) {
            const created = new Date(logsResponse.data.logs[i].created * 1000);
            const user = this.users.data.find(x => x.key == logsResponse.data.logs[i].userId);
            const userName = user ? user.label : "";

            this.logs.push({
              created: utilsService.formatDateTime(created, utilsService.DATE_TIME_FORMAT),
              user: userName,
              message: this.createLogMessage(logsResponse.data.logs[i])
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.validationError = error;
      }

      this.isLogsLoading = false;
    },
    selectedPeriodTimesToday() {
      const today = new Date();

      const beginDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = beginDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesYesterday() {
      const today = new Date();

      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      const beginDateString = new Date(
        yesterday.getTime() - yesterday.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = beginDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesLastWeek() {
      const today = new Date();

      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7);

      const beginDateString = new Date(
        lastWeek.getTime() - lastWeek.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      const endDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = endDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesLastMonth() {
      const today = new Date();

      const lastMonth = new Date(today);
      lastMonth.setDate(today.getDate() - 30);

      const beginDateString = new Date(
        lastMonth.getTime() - lastMonth.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      const endDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = endDateString;
      this.endTime = "23:59:00";
    },
    createLogMessage(log) {
      const logType = log.logType.toString();
      let template = this.$store.state.localization.data.mainPage.logs.templates[logType]

      if (template) {
        if (log.message) {
            let message = JSON.parse(log.message);
  
            for (const key of Object.keys(message)) {
              if (this.$store.state.localization.data.mainPage.logs.details[key]) {
                message[this.$store.state.localization.data.mainPage.logs.details[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.users.tableColumns[key]) {
                if (key == "isActiveToUntillTime") {
                  if (Array.isArray(message[key])) {
                    const oldValue = new Date(message[key][0] * 1000).toLocaleDateString();
                    const newValue = new Date(message[key][1] * 1000).toLocaleDateString();
                    message[this.$store.state.localization.data.mainPage.azk.users.tableColumns[key]] = [oldValue, newValue];
                  } else {
                    message[this.$store.state.localization.data.mainPage.azk.users.tableColumns[key]] = new Date(message[key] * 1000).toLocaleDateString();
                  }

                } else {
                  message[this.$store.state.localization.data.mainPage.azk.users.tableColumns[key]] = message[key];
                }
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.globalSettings.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.globalSettings.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.fuelTanks.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.vehicles.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.vehicles.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.trks.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.trks.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.guns.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.guns.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.fuelDepos.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.fuelDepos.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.users.userInfo.tabs[key]) {
                message[this.$store.state.localization.data.mainPage.users.userInfo.tabs[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.suppliers.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.suppliers.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.drivers.tableColumns[key]) {
                message[this.$store.state.localization.data.mainPage.azk.drivers.tableColumns[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.fuelTankCard[key]) {
                message[this.$store.state.localization.data.mainPage.fuelTankCard[key]] = message[key];
                delete message[key];
              } else if (this.$store.state.localization.data.mainPage.azk.arm[key]) {
                message[this.$store.state.localization.data.mainPage.azk.arm[key]] = message[key];
                delete message[key];
              }
            }
          return `${template} : ${JSON.stringify(message)}`;
        }

        return `${template}`;
      } else {
        return `${this.$store.state.localization.data.mainPage.logs.templates["0"]}`;
      }
    }
  },
};
</script>

<style>
.textMiddle {
  vertical-align: middle !important;
  text-align: center !important;
  min-width: 20px !important;
}

.textNarrow {
  max-width: 800px;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

</style>
